import { useCallback } from "react";
import Block, { IBlock } from "./Block";

type IProps = {
	blocks: IBlock[];
	onSelectedBlock: (block: IBlock) => void;
};
import { LoggerService } from "@Front/Services/LoggerService/LoggerService";

export default function BlockList({ blocks, onSelectedBlock }: IProps): React.JSX.Element {
	const selectBlock = useCallback(
		(id: string) => {
			LoggerService.debug("🔍 [BlockList] selectBlock called", {
				blockId: id,
				blocksCount: blocks.length,
				hasOnSelectedBlock: !!onSelectedBlock,
			});
			const block = blocks.find((folder) => folder.id === id);
			if (block) {
				LoggerService.debug("🔍 [BlockList] Block found, calling onSelectedBlock", {
					blockId: block.id,
					hasStatusBadge: !!block.statusBadge,
				});
				onSelectedBlock(block);
			} else {
				LoggerService.warn("⚠️ [BlockList] Block not found", {
					blockId: id,
					blocksCount: blocks.length,
					availableIds: blocks.map((b) => b.id).slice(0, 5),
				});
			}
		},
		[blocks, onSelectedBlock],
	);

	return (
		<div>
			{blocks.map((block) => {
				// Use composite key including statusBadge to force React to recreate Block when badge changes
				// This ensures UI updates even if React thinks it's the same component
				const blockKey = `${block.id}-${block.statusBadge ?? "no-badge"}-${block.officeColor ?? "no-color"}`;
				return <Block {...block} hasSeparator onClick={selectBlock} key={blockKey} />;
			})}
		</div>
	);
}
